import { printPdf } from 'ts/common/utils';

interface UsePrintOrDownloadContractReturn {
    printContract: () => Promise<void>;
    downloadContract: () => void;
}

export const usePrintOrDownloadContract = (
    contractUrl: string
): UsePrintOrDownloadContractReturn => {
    const printContract = () => {
        return printPdf(contractUrl);
    };

    const downloadContract = () => {
        window.open(contractUrl, '_blank');
    };

    return {
        printContract,
        downloadContract
    };
};
